import React from 'react';
import { InformationTooltip } from '@michelin/acid-components';

export const MarginTooltip = ({ title }: { title: JSX.Element }) => {
  return (
    <span style={{ marginLeft: 10 }}>
      <InformationTooltip tooltipVariant="light" title={title} />
    </span>
  );
};
